import {
    doPostCreateManufacturingDevices, editManufacturingDevice,
    getAllManufacturingDevices,
    getManufacturingDevices
} from "../../../api/manufacturing/manufacturing.api";
import manufacturingActions from "./manufacturingActions"
import {all, takeEvery, call, put} from 'redux-saga/effects';
import notifications from "../notification/actions";
import {SERVER_ERRORS} from "../../../api/SERVER_ERRORS";

const {createManufacturingDevicesSuccess, fetchManufacturingDevicesSuccess, editManufacturingDeviceSuccess, fetchAllManufacturingDevicesSuccess} = manufacturingActions

function* createManufacturingDevicesSaga(action) {
    try {
        const response = yield call(doPostCreateManufacturingDevices, action.devices);
        if (response && response.resp && response.resp.length > 0) {
            const responseData = response.resp
            const failedDeviceNumber = responseData.filter((device) => device.message)
            const successDeviceNumber = responseData.filter((device) => !device.message)
            let message = ""
            let statusMsg = ''
            if (successDeviceNumber.length < 1) {
                message = `Failed to insert the devices this time. Please see the record status for details.`
                statusMsg = 'ERROR'
            }
            else if (successDeviceNumber.length > 0 && failedDeviceNumber.length > 0){
                message = `Successfully insert ${successDeviceNumber.length} devices. but ${failedDeviceNumber.length} failed. Please see the record status for details.`
                statusMsg = 'WARNING'
            }
            else {
                message = `Successfully insert ${successDeviceNumber.length} devices.`
                statusMsg = 'SUCCESS'
            }
            yield all([
                put(notifications.createNotification({
                    message: message,
                    status: statusMsg,
                })),
                put(createManufacturingDevicesSuccess(responseData))
            ])
        } else {
            if (response.status === SERVER_ERRORS.COULD_NOT_CREATE_MANUFACTURING_DEVICES) {
                yield put(notifications.createNotification({
                    message: response[0].message,
                    mainAction: manufacturingActions.CREATE_MANUFACTURING_DEVICES_ERROR,
                    duration: 15
                }));
            }
                else if (response[0].code === SERVER_ERRORS.COULD_NOT_DELETE_UPDATE_PACKAGE_RECORD) {
                    yield put(notifications.createNotification({
                        message: response[0].message,
                        // mainAction: actions.CREATE_MANUFACTURING_DEVICES_ERROR,
                    }))
            }
            else {
                yield put(notifications.createNotification({
                    ...response[0],
                    mainAction: manufacturingActions.CREATE_MANUFACTURING_DEVICES_ERROR,
                    duration: 15
                }));
            }
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: manufacturingActions.CREATE_MANUFACTURING_DEVICES_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR,
            duration: 15
        }));
    }
}

function* editManufacturingDeviceSaga(device) {
    try {
         const response = yield call(editManufacturingDevice, device)
         if (response.updated === 'OK') {
             put(notifications.createNotification({
                 message: `Successfully modify the record.`,
                 status: "SUCCESS",
             }))
             yield put(editManufacturingDeviceSuccess())
         }
    } catch (e) {
        yield put(notifications.createNotification({
            mainAction: manufacturingActions.CREATE_MANUFACTURING_DEVICES_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR,
            duration: 15
        }));
    }
}

function* fetchManufacturingDevicesSaga(payload) {
    try {
        const response = yield call(getManufacturingDevices, payload ?payload.search : {})
        if (response.resp) {
            put(notifications.createNotification({
                message: `Successfully fetch. Please see the record status for details.`,
                status: "SUCCESS",
            }))
            let responseData = response.resp
            yield put(fetchManufacturingDevicesSuccess(responseData))
        }
        else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: manufacturingActions.FETCH_MANUFACTURING_DEVICES_ERROR
            }))
        }
    } catch (error) {
        yield put(notifications.createNotification({
            code: SERVER_ERRORS.COULD_NOT_FIND_DEVICES,
            mainAction: manufacturingActions.FETCH_MANUFACTURING_DEVICES_ERROR
        }))
    }
}

function* fetchAllManufacturingDevicesSaga(payload) {
    try {
        const response = yield call(getAllManufacturingDevices)
        if (response.resp) {
            let responseData = response.resp
            yield put(fetchAllManufacturingDevicesSuccess(responseData))
        }
        else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: manufacturingActions.FETCH_MANUFACTURING_DEVICES_ERROR
            }))
        }
    } catch (error) {
        yield put(notifications.createNotification({
            code: SERVER_ERRORS.COULD_NOT_FIND_DEVICES,
            mainAction: manufacturingActions.FETCH_MANUFACTURING_DEVICES_ERROR
        }))
    }
}
export default function* rootSaga() {
    yield all([
        takeEvery(manufacturingActions.CREATE_MANUFACTURING_DEVICES, createManufacturingDevicesSaga),
        takeEvery(manufacturingActions.FETCH_MANUFACTURING_DEVICES, fetchManufacturingDevicesSaga),
        takeEvery(manufacturingActions.FETCH_ALL_MANUFACTURING_DEVICES, fetchAllManufacturingDevicesSaga),
        takeEvery(manufacturingActions.EDIT_MANUFACTURING_DEVICE, editManufacturingDeviceSaga)
    ]);
}
